<template>
  <header :style="bannerStyle">
    <div class="button-wrap" v-if="!hideButton">
      <div class="button-login" @click="login">
        <span>{{ NICK_NAME ? NICK_NAME : "ログイン" }}</span>
      </div>

      <div class="button-submit" @click="upload">
        <span>応募</span>
      </div>
    </div>
    <!-- <div class="season-box" v-show="!hideSeason">
      <p class="season-tip">PREVIOUS EVENTS</p>
      <season-select
        :options-list="seasonList"
        :default-value="defaultSeasonRouteName"
        v-model="seasonRouteName"
      ></season-select>
    </div> -->
  </header>
</template>

<script>
import { mapState } from "vuex";
import seasonSelect from "@/components/Select";

export default {
  name: "Header",

  components: {
    seasonSelect,
  },
  data: () => ({
    hideButton: false,
    hideSeason: false,
    seasonList: [],
    seasonRouteName: "",
    defaultSeasonRouteName: "",
    seasonInfo: [],
  }),
  created() {
    this.getSetup();
    this.hideButton = this.$route.meta.hideButton;
    this.hideSeason = this.$route.meta.hideSeason;
  },
  mounted() {},
  watch: {
    $route(to) {
      this.hideButton = to.meta.hideButton;
      this.hideSeason = to.meta.hideSeason;
      if (to.path === "/" && this.seasonList.length !== 0) {
        this.$router.push({
          path: `/${this.seasonList[0].value}`,
        });
      }
      if (to.params && to.params.routeName) {
        this.defaultSeasonRouteName = to.params.routeName;
      }
    },
    seasonRouteName(val) {
      if (val !== this.$route.params.routeName) {
        this.$router.push({
          path: `/${val}`,
        });
      }
    },
  },
  computed: {
    ...mapState({
      NICK_NAME: (state) => state.User.NICK_NAME,
      CUR_SEASON: (state) => state.Home.CUR_SEASON,
    }),
    VUE_APP_CDN() {
      return process.env.VUE_APP_CDN;
    },
    bannerStyle() {
      return {
        "background-image": `url(${this.VUE_APP_CDN}/${this.CUR_SEASON.banner})`,
        "background-size": "cover"
      };
    },
  },
  methods: {
    async getSetup() {
      const setup = await this.axios.get("/setup");
      console.log("setup", setup);
      this.seasonInfo = setup.data.publishSeasonList;
      this.$store.commit("Home/SET_SEASON_INFO", this.seasonInfo);
      this.seasonList = setup.data.publishSeasonList.map((item) => {
        return {
          label: item.routeName,
          value: item.routeName,
        };
      });
      if (this.$route.path === "/") {
        this.$router.push({
          path: `/${this.seasonList[0].value}`,
        });
      }
      if (this.$route.params && this.$route.params.routeName) {
        this.defaultSeasonRouteName = this.$route.params.routeName;
      }
    },
    login() {
      if (!this.NICK_NAME) {
        this.$store.commit("LoginMask/SET_MASK_ACTIVE", true);
      } else {
        
        if(!window.confirm("ログアウトしますか？")) {
          return
        }
        this.$store
          .dispatch("User/logout")
          .then((v) => {
            if (v.retcode == 2000) {
              this.$router.replace({ path: "/" });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    upload() {
      const curSeason = this.CUR_SEASON;
      const curTime = new Date();

      if (
        curTime >= new Date(curSeason.submitStartTime) &&
        curTime < new Date(curSeason.submitEndTime)
      ) {
        this.$router.push({ path: `/upload/${curSeason.routeName}` });
      } else if (curTime < new Date(curSeason.submitStartTime)) {
        alert(
          "応募期間外です。詳細はアークナイツ公式Twitterをご確認ください。"
        );
      } else if (curTime > new Date(curSeason.submitEndTime)) {
        alert(
          "応募期間外です。詳細はアークナイツ公式Twitterをご確認ください。"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 0;
  padding-bottom: 22.24%;
  background-size: 100%;
  position: relative;

  .button-wrap {
    position: absolute;
    top: pxTorem(81px);
    right: pxTorem(188px);
    display: flex;
    align-items: center;

    .button-login {
      width: pxTorem(116px);
      height: pxTorem(41px);
      background: url('../assets/images/header/login_button.png');
      background-size: 100% 100%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      

      span {
        z-index: 2;
        color: #000;
        font-size: pxTorem(16px);
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: url("../assets/images/header/login_button_hover.png") no-repeat;
        background-size: 100%;
        opacity: 0;
        transition: opacity .3s ease-in-out;
        z-index: 1;
      }
      &:hover::after{
        opacity: 1;
      }
    }
    
    .button-submit {
      @extend .button-login;
      margin-left: pxTorem(30px)
    }
  }
  .season-box {
    width: pxTorem(132px);
    height: pxTorem(26px);
    position: absolute;
    right: pxTorem(140px);
    bottom: pxTorem(15px);

    .season-tip {
      font-size: pxTorem(16px);
      color: #fff;
      white-space: nowrap;
      position: absolute;
      left: 0;
      bottom: 110%;
      text-shadow: 0 3px 10px rgba(0, 0, 0, 1);
      font-weight: bold;
    }
  }
}
</style>
